import React, { useState } from "react";

interface FaqItem {
    id: number;
    q: string;
    a: string;
}

interface FaqListProps {
    items: FaqItem[];
    defaultOpenId?: number | null;
    renderAnswer?: (text: string) => React.ReactNode;
}

export function FaqList({ items, defaultOpenId = null, renderAnswer }: FaqListProps) {
    const [openFaq, setOpenFaq] = useState<number | null>(defaultOpenId);
    return (
        <div className="flex flex-col">
            {items.map((faq, idx) => {
                const isOpen = openFaq === faq.id;
                const isLast = idx === items.length - 1;
                return (
                    <div key={faq.id} className={isLast ? "" : "border-b border-border-token"}>
                        <button
                            type="button"
                            onClick={() => setOpenFaq(isOpen ? null : faq.id)}
                            className="w-full flex items-center justify-between gap-3 py-3 border-0 bg-transparent cursor-pointer text-left font-[inherit]"
                        >
                            <span
                                className={`text-[13px] font-semibold leading-[1.4] ${
                                    isOpen ? "text-accent-text" : "text-text-1"
                                }`}
                            >
                                {faq.q}
                            </span>
                            <svg
                                width="16"
                                height="16"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                className={`shrink-0 transition-transform ${
                                    isOpen ? "rotate-180 text-accent-text" : "text-muted"
                                }`}
                            >
                                <polyline points="6 9 12 15 18 9" />
                            </svg>
                        </button>
                        {isOpen && (
                            <div className="text-[13px] text-text-2 leading-[1.65] pb-3.5">
                                {renderAnswer ? renderAnswer(faq.a) : faq.a}
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
}
